import $ from 'jquery'

$( document ).ready(function() {
})